export default __webpack_public_path__ + "static/media/t44.055bc4aa.jpg";